import { InvoiceCategoryFilter } from '@treadinc/horizon-api-spec';
export const payableInvoiceCategories = [
  InvoiceCategoryFilter.INTERNAL_PAYABLES,
  InvoiceCategoryFilter.OWNER_OPERATOR_PAYABLES,
  InvoiceCategoryFilter.PAYABLES,
  InvoiceCategoryFilter.VENDOR_PAYABLES,
];

export const receivableInvoiceCategories = [
  InvoiceCategoryFilter.ACCOUNT_RECEIVABLES,
  InvoiceCategoryFilter.CONNECTION_RECEIVABLES,
  InvoiceCategoryFilter.RECEIVABLES,
];
